import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

// settings รวม (loyalty + promotion flags) — endpoint เดียว /v1/settings
class SettingApi {
	async get() {
		try {
			const response = await axios.get(BASE_URI + '/v1/settings' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/settings' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Setting = new SettingApi();
